import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'hammerjs';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));


// START ************** /
// bug fix for chrome keyboard/change orientation

const hack = () => {
  const ionApp = document.querySelector('ion-app');

  if (ionApp) {
    window.requestAnimationFrame(() => {
      ionApp.style.height = '100%';
      window.requestAnimationFrame(() => {
        ionApp.style.height = '';
      });
    });
  }
};

let resizerObserver;

document.addEventListener('DOMContentLoaded', () => {
  if (!window) {
    return;
  }

  if ('ResizeObserver' in window) {
    const ResizeObserver = (window as any).ResizeObserver;
    resizerObserver = new ResizeObserver(hack);
    resizerObserver.observe(document.documentElement);
  } else {
    (window as Window).addEventListener('keyboardWillShow', hack);
    (window as Window).addEventListener('keyboardWillHide', hack);
    (window as Window).addEventListener('resize', hack);
  }
});

window.addEventListener('unload', () => {
  if (!window) {
    return;
  }

  if ('ResizeObserver' in window) {
    if (resizerObserver) {
      resizerObserver.unobserve(document.documentElement);
      resizerObserver.disconnect();
    }
  } else {
    (window as Window).removeEventListener('keyboardWillShow', hack);
    (window as Window).removeEventListener('keyboardWillHide', hack);
    (window as Window).removeEventListener('resize', hack);
  }
});

// END ************** /
